import { ReferenceKind } from "@ctrl/controller-rpc";

export const getOrdinal = (number: number): string => {
  const j = number % 10;
  const k = number % 100;
  if (j == 1 && k != 11) {
    return number + "st";
  }
  if (j == 2 && k != 12) {
    return number + "nd";
  }
  if (j == 3 && k != 13) {
    return number + "rd";
  }
  return number + "th";
};

export const getFaviconUrl = (url: string, size = 128): string | undefined => {
  try {
    const [, , host] = url.split("/");
    return `https://www.google.com/s2/favicons?domain=${host}&sz=${size}`;
  } catch {
    return undefined;
  }
};

//FIXME: GRAPH not robust
export const identifyKind = (kind: ReferenceKind, id: string): boolean =>
  id.startsWith(`${kind}:`);
